import React from 'react';
import { RootState, useSelector } from 'src/store';

export const RenderingLoader = () => {
  const { renderState } = useSelector((state: RootState) => state.renderRequest);
  if (renderState !== 'running') return null;

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,.4)',
      zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <div style={{ color: '#fff', fontFamily: 'var(--font-mono)', fontSize: '.85rem', letterSpacing: '.12em' }}>
        Rendering…
      </div>
    </div>
  );
};
